<template>
  <div v-if="time.length>=2">
    <div>
      <div class="flex-container">
      <span class="name-right">{{ time[0].name }}:</span>
        <span v-if="hashTime(time[0].time,scope.record)!==null" class="time-left">
          <span v-if="!isStringWithinLimit(hashTime(time[0].time,scope.record),20)">
            {{hashTime(time[0].time,scope.record)}}
          </span>
          <w-ellipsis-and-look v-if="isStringWithinLimit(hashTime(time[0].time,scope.record),20)" style="margin-left:5px" class="w-ellipsis-and-look" :text="hashTime(time[0].time,scope.record)"
                               :column="{title:time[0].name}" :onlyDetail="true" :isOpenHtml="false">
          </w-ellipsis-and-look>
        </span>
        <el-tooltip content="折叠更多" v-if="showToolTip[scope.index]">
          <i class="el-icon-caret-top iconMore" @click="openMore(scope.index)"></i>
        </el-tooltip>
        <el-tooltip content="展开更多" v-if="!showToolTip[scope.index]">
          <i class="el-icon-caret-bottom iconMore" @click="openMore(scope.index)"></i>
        </el-tooltip>
    </div>
      <div v-for="(con,index1) in time" :key="index1" v-if="showToolTip[scope.index]">

        <div v-if="index1 !== 0 && hashTime(con.time,scope.record)" class="flex-container">
          <span class="name-right">{{ con.name }}:</span>
          <span v-if="hashTime(con.time,scope.record)" class="time-left">
            <span v-if="!isStringWithinLimit(hashTime(con.time,scope.record),20)">
              {{hashTime(con.time,scope.record)}}
            </span>
            <w-ellipsis-and-look v-if="isStringWithinLimit(hashTime(con.time,scope.record),20)" style="margin-left:5px" class="w-ellipsis-and-look" :text="hashTime(con.time,scope.record)"
                                 :column="{title:con.name}" :onlyDetail="true"
                                 :isOpenHtml="false">
            </w-ellipsis-and-look>
          </span>
        </div>
      </div>
    </div>
  </div>
  <div v-else-if="time.length>0 && time.length<2" class="flex-container">
    <span class="name-right"> {{ time[0].name }}:</span>
    <span v-if="!isStringWithinLimit(hashTime(time[0].time, scope.record), 10) || ['NGS', 'PACBIO', 'HIC', 'ONT'].includes(time[0].time)" class="time-left">
      {{hashTime(time[0].time,scope.record)}}
    </span>
    <w-ellipsis-and-look v-if="isStringWithinLimit(hashTime(time[0].time, scope.record), 10) && !['NGS', 'PACBIO', 'HIC', 'ONT'].includes(time[0].time)" style="margin-left:5px" class="w-ellipsis-and-look" :text="hashTime(time[0].time,scope.record)"
                         :column="{title:time[0].name}" :onlyDetail="true" :isOpenHtml="false">
    </w-ellipsis-and-look>
  </div>
</template>

<script>
import {formatNumberWithUnit} from "@/store/date";

export default {
  name: "ExFoldTable",
  props: ['scope',],
  data() {
    return {
      showToolTip: [],
    }
  },
  computed:{
    time(){
      return this.scope.time.filter(item => this.hashTime(item.time,this.scope.record))
    }
  },
  methods: {
    isStringWithinLimit(str, maxLength) {
      return str.length >= maxLength;
    },
    hashTime(time,record){
      if(Array.isArray(record)){
        let num = ''
        for(let [index, data] of record.entries()){
          num = num + this.hashTime(time,data[this.scope.dataIndex]) + (index !== record.length-1?'/':'')
        }
        return num
      }
      if (time.includes('.')) {
        const keys = time.split('.');
        if([true,false].includes(keys.reduce((obj, key) => obj && obj[key], record))){
          return keys.reduce((obj, key) => obj && obj[key], record)?'是':'否';
        }else if(keys.reduce((obj, key) => obj && obj[key], record) === null){
          return 0
        }
        return keys.reduce((obj, key) => obj && obj[key], record);
      }
      if([true,false].includes(record[time])){
        return record[time]?'是':'';
      }else if(record[time]===null){
        return 0
      }else if(['NGS','PACBIO','HIC','ONT'].includes(time)){
        const dataAmountUnit = time === 'ONT' ?'Cell':this.scope.dataAmountUnit;
        return formatNumberWithUnit(Number(record[time])) + '('+ dataAmountUnit +')' 
      }
      return record[time]
    },
    openMore(index) {
      this.$set(this.showToolTip, index, !this.showToolTip[index]);
    }
  }
}
</script>

<style scoped>
.iconMore {
  color: #4eaad4;
  cursor: pointer;
}
.flex-container {
  display: flex;
  align-items: center; /* 垂直居中对齐 */
  max-width: 600px; /* 根据需要调整最大宽度 */
  margin: 0 auto; /* 居中整个容器 */
}

.name-right {
  text-align: right; /* 右对齐名称部分 */
  margin-right: 10px; /* 可选：添加右侧间距 */
}

.time-left {
  text-align: left; /* 左对齐时间部分 */
}
</style>
